<template>
	<div v-if="totalItens === length">
		<v-row justify="center" class="arp-no-data-table-row">
			<v-col cols="12" class="align-center d-flex flex-column grey--text justify-center">
				<v-icon class="arp-icon-no-data mb-1" size="60">mdi-archive-outline</v-icon>
				<h3>{{ textos.titulo }}</h3>
				<p
					v-if="textos.mensagem"
					:class="{ 'arp-no-data-table-mensagem': !textos.titulo }"
					v-html="textos.mensagem"
				></p>
				<botao-primario
					v-if="botao"
					:nome-botao="botao.nome"
					:icone="botao.icone"
					v-az-auth="permissao"
					@click="$emit('botao-evento')"
				></botao-primario>
				<slot name="acoes" v-if="$slots.acoes"></slot>
			</v-col>
		</v-row>
	</div>
</template>

<script>
export default {
	name: 'template-listagem-vazia',
	props: {
		totalItens: {
			type: Number,
			default: 0,
		},
		length: {
			type: Number,
			default: 0,
		},
		textos: {
			type: Object,
			default: function () {
				return {
					titulo: null,
					mensagem: null,
				}
			},
		},
		permissao: {
			type: String,
			default: '',
		},
		botao: {
			type: Object,
			default: function () {
				return null
			},
		},
	},
	emits: ['botao-evento'],
}
</script>
